import React from 'react';
import { useInfoCeldas } from './InfoCeldasContext';
import { ArrowNarrowRight } from 'tabler-icons-react';

export default function GeneralData() {
    const { detailOrder } = useInfoCeldas();

    return (
        <div className="InfoCeldaGeneralDataTittle">
            <div className="InfoCeldaGeneralDataTitulo">
                <p>Datos Generales de la corrida</p>
            </div>
            <div className="InfoCeldaGeneralDataFields">
                <div className="InfoCeldaGeneralDataField">
                    <h1>Producto</h1>
                    <h3>{detailOrder.nombre.toLowerCase()}</h3>
                </div>
            </div>

            <div className="InfoCeldaGeneralDataFields">
                <div className="InfoCeldaGeneralDataField">
                    <h1>Orden</h1>
                    <h2>{detailOrder.ordenProd}</h2>
                </div>
                <div className="InfoCeldaGeneralDataField">
                    <h1>Meta</h1>
                    <h2>{detailOrder.meta}</h2>
                </div>
            </div>

            <div className="InfoCeldaGeneralDataFields">
                <div className="InfoCeldaGeneralDataField">
                    <h1>Plan</h1>

                    <div className="InfoCeldaGeneralDataFieldHorario">
                        <div className="InfoCeldaGeneralDataFieldHorarioField">
                            <h2>
                                inicio
                                <br />
                            </h2>
                            {detailOrder.fechaIni.slice(8, 10)}
                            {'/'}
                            {detailOrder.fechaIni.slice(5, 7)}

                            <div>{detailOrder.fechaIni.slice(11, 16)}</div>
                        </div>
                        {/* 12/12/23 08:30 */}
                        <div className="InfoCeldaGeneralDataFieldHorarioField">
                            <ArrowNarrowRight
                                className="InfoCeldaGeneralDataFieldHorarioFieldArrow"
                                size={30}
                                strokeWidth={2}
                            />
                        </div>
                        <div className="InfoCeldaGeneralDataFieldHorarioField">
                            <h2>
                                Fin
                                <br />
                            </h2>
                            {detailOrder.fechaFin.slice(8, 10)}
                            {'/'}
                            {detailOrder.fechaFin.slice(5, 7)}

                            <div>{detailOrder.fechaFin.slice(11, 16)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
